import { isKITProduct } from "~/domains/product/types/ProductData";
import { HousingMessages } from "~/domains/housing/components/HousingMessages";
import { SaleTag } from "~/domains/salesCampaign/components/SaleTag/SaleTag";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

import { Box, Stack, styled } from "~/common/mui";
import { useSalesHelper } from "~/domains/salesCampaign/utils/salesHelper";
import { Product } from "~/domains/product/Product";
import { ProductDetailsSection } from "~/features/productDetails/components/ProductSummary/components/ProductDetailsSection";
import { SaleEndIndicator } from "~/domains/salesCampaign/components/SaleEndIndicator/SaleEndIndicator";
import { NewVersionMessage } from "~/common/components/Messages/NewVersionMessage";

interface Props {
  descriptor: ProductDescriptor;
  packCode: string;
}

export const AtcProductDetails = (props: Props) => {
  const { descriptor, packCode } = props;
  const product = descriptor.base;

  const salesHelper = useSalesHelper(descriptor);
  const hasSales = salesHelper.isProductOnSale();

  const saleData = salesHelper.forPackage(packCode);
  const saleEndDate = saleData?.endDate;

  const isHousingKit = isKITProduct(product);

  return (
    <Stack gap={2}>
      <Box sx={{ position: "relative" }}>
        {hasSales && (
          <SaleTag
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
          />
        )}
        <Product.PrimaryImageWithLogosV2 logoWidth={32} gap={8} size={96} />
      </Box>
      {isHousingKit && <HousingMessages.NotFinal />}

      {saleEndDate && <SaleEndIndicatorStyled endDate={saleEndDate} />}

      <NewVersionMessage baseProduct={product} />

      <ProductDetailsSection />
    </Stack>
  );
};

const SaleEndIndicatorStyled = styled(SaleEndIndicator.V2)({
  alignSelf: "flex-start",
});
